import { Nullable } from '../common/types';
import api from './api';

export type HubDevice = {
  duid: string;
  serialNumber: string;
  status: string;
  siteId?: string;
  farmName: string;
  customerName: Nullable<string>;
  customerNumber: Nullable<string>;
  lelyCenter: Nullable<string>;
  lelyCluster: Nullable<string>;
  isFavourite?: boolean; // FE
  uri?: string;
};

type DeviceLinkArgs = {
  serialNumber: string;
  siteId: string;
};

type DeviceAddArgs = {
  serialNumber: string;
  distributionPartnerId: string;
};

type Center = {
  salesforceAccountNumber: string;
  commercialName: string;
};

const HUB_DEVICES_URL = '/hubdevices';

export const hubDevicesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getHubDevices: build.query<HubDevice[], void>({
      query: () => ({
        url: HUB_DEVICES_URL,
      }),

      providesTags: ['HubDevices'],
    }),

    getCenters: build.query<Center[], string>({
      query: (id) => ({
        url: `${HUB_DEVICES_URL}/${id}/lely_centers`,
      }),

      providesTags: ['Centers'],
    }),

    addHubDevice: build.mutation<void, DeviceAddArgs>({
      query: ({ serialNumber, distributionPartnerId }) => ({
        url: `${HUB_DEVICES_URL}/${serialNumber}/distribution_partner_id`,
        method: 'PUT',
        body: { distributionPartnerId },
      }),
      invalidatesTags: ['HubDevices'],
    }),

    removeHubDevice: build.mutation<void, string>({
      query: (serialNumber) => ({
        url: `${HUB_DEVICES_URL}/${serialNumber}/distribution_partner_id`,
        method: 'DELETE',
      }),
      invalidatesTags: ['HubDevices'],
    }),

    linkHubDevice: build.mutation<void, DeviceLinkArgs>({
      query: ({ serialNumber, siteId }) => ({
        url: `${HUB_DEVICES_URL}/${serialNumber}/site_id`,
        method: 'PUT',
        body: {
          siteId,
        },
      }),
      invalidatesTags: ['HubDevices'],
    }),

    unlinkHubDevice: build.mutation<void, string>({
      query: (serialNumber) => ({
        url: `${HUB_DEVICES_URL}/${serialNumber}/site_id`,
        method: 'DELETE',
      }),
      invalidatesTags: ['HubDevices'],
    }),
  }),
});

export const {
  useGetHubDevicesQuery,
  useGetCentersQuery,
  useAddHubDeviceMutation,
  useRemoveHubDeviceMutation,
  useLinkHubDeviceMutation,
  useUnlinkHubDeviceMutation,
} = hubDevicesApi;
